import React from "react";

import "./css/post-79.css";
import "./css/post-2521.css";
import "./css/widget-cmsmasters-icon-list.min.css";
import "./css/post-2486.css";
import FaqPage from "./component/FaqPage";
import { useParams } from "react-router-dom";
import RiceCategory from "./component/RiceCategory";
import ServiceData from "./ServiceData"
const Service = () => {
  const { serviceName } = useParams(); // Get the service name from the URL
  const service = ServiceData[serviceName];
  console.log("service", service); // Get the corresponding service data
  if (!service) {
    return <h2>Service not found</h2>; // Handle case where service is not found
  }
  return (
    <div
      data-elementor-type="cmsmasters_singular"
      data-elementor-id={79}
      className="elementor elementor-79 cmsmasters-location-cmsmasters_singular cmsmasters-header-position-absolute- post-2521 cmsms_service type-cmsms_service status-publish has-post-thumbnail hentry"
    >
      {" "}
      <div className="elementor-inner">
        <div className="elementor-section-wrap">
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-dd5847e elementor-section-full_width elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
            data-id="dd5847e"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-11ebb65c"
                data-id="11ebb65c"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-57223135 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-wide">
                      <div
                        className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-3d3b673e"
                        data-id="3d3b673e"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-1b6b4b94 cmsmasters-separator-type-icon cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-breadcrumbs cmsmasters-widget-breadcrumbs"
                            data-id="1b6b4b94"
                            data-element_type="widget"
                            data-widget_type="cmsmasters-breadcrumbs.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="cmsmasters-widget-breadcrumbs__container">
                                <div className="cmsmasters-widget-breadcrumbs__content">
                                  <a type="button" className="cmsmasters-home">
                                    Service
                                  </a>
                                  <span className="cmsmasters-widget-breadcrumbs__sep">
                                    <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-right" />
                                  </span>
                                  <span> {service.crum}</span>
                                </div>
                              </div>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-4a460e8f elementor-section-full_width elementor-section-content-middle elementor-reverse-tablet elementor-reverse-mobile elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
            data-id="4a460e8f"
            data-element_type="section"
            data-settings='{"background_background":"classic"}'
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-437d757b"
                data-id="437d757b"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-24d472e0 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                    data-id="24d472e0"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-wide">
                      <div
                        className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-31606ab8"
                        data-id="31606ab8"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-68733a97 cmsmasters-line-clamp-no cmsmasters-color-variation-default cmsmasters-pointer-none cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-title cmsmasters-widget-title"
                            data-id="68733a97"
                            data-element_type="widget"
                            data-widget_type="cmsmasters-post-title.default"
                          >
                            <div className="elementor-widget-container">
                              <h1 className="entry-title cmsmasters-widget-title__heading ">
                                {service.title}
                              </h1>{" "}
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-6e0abb96 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                            data-id="6e0abb96"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-heading-title elementor-size-default">
                                {service.subtitle}
                              </div>{" "}
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-4a6b1db2 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-text-editor"
                            data-id="4a6b1db2"
                            data-element_type="widget"
                            data-widget_type="text-editor.default"
                          >
                            <div className="elementor-widget-container" style={{ textAlign: "justify" }}>
                              {service.description}
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-3bef50e cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                            data-id="3bef50e"
                            data-element_type="widget"
                            data-widget_type="cmsmasters-button.default"
                          >
                            {/* <div className="elementor-widget-container">
                              <div className="elementor-widget-cmsmasters-button__button-container">
                                <div className="elementor-widget-cmsmasters-button__button-container-inner">
                                  <a
                                    href="/"
                                    className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view- cmsmasters-icon-shape- cmsmasters-button-size-sm"
                                    role="button"
                                  >
                                    <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-">
                                      <span className="elementor-widget-cmsmasters-button__text">
                                        Open Account
                                      </span>
                                    </span>
                                  </a>
                                </div>
                              </div>{" "}
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
              <div
                className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3a9f7d51"
                data-id="3a9f7d51"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-3da44cb2 cmsmasters-object-fit cmsmasters-object-fit-cover cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-featured-image cmsmasters-widget-image"
                    data-id="3da44cb2"
                    data-element_type="widget"
                    data-widget_type="cmsmasters-post-featured-image.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="cmsmasters-widget-image__wrap">
                        <a
                          href="/"
                          data-elementor-open-lightbox
                          aria-label="Featured Image"
                        >
                          <img
                            width={1024}
                            height={677}
                            src={service.image}
                            className="attachment-large size-large wp-image-2531 cmsmasters_img cmsmasters-lazyload lazyloaded"
                            alt="buroojtrading"
                            decoding="async"
                            data-sizes="(max-width: 1024px) 100vw, 1024px"
                            // data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-1024x677.jpg"
                            // data-srcset="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-1024x677.jpg 1024w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-300x198.jpg 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-768x508.jpg 768w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-454x300.jpg 454w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-600x397.jpg 600w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-30x20.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-15x10.jpg 15w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9.jpg 1180w"
                            sizes="(max-width: 1024px) 100vw, 1024px"
                          // srcSet="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-1024x677.jpg 1024w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-300x198.jpg 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-768x508.jpg 768w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-454x300.jpg 454w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-600x397.jpg 600w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-30x20.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9-15x10.jpg 15w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/10/service-9.jpg 1180w"
                          />
                        </a>
                      </div>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-a1fe329 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
            data-id="a1fe329"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4590363"
                data-id={4590363}
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-4756c81 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                    data-id="4756c81"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div
                      className="elementor-widget-container"
                      style={{ margin: "7%", textAlign: "center" }}
                    >
                      <h2 className="elementor-heading-title elementor-size-default">
                        {service.offerings.title}
                      </h2>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-7a3d0962 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
            data-id="7a3d0962"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-wide">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3a4228b7"
                data-id="3a4228b7"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-12b155b0 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-content cmsmasters-widget-content elementor-widget-theme-post-content"
                    data-id="12b155b0"
                    data-element_type="widget"
                    data-widget_type="cmsmasters-post-content.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="entry-content">
                        <div
                          data-elementor-type="wp-post"
                          data-elementor-id={2486}
                          className="elementor elementor-2486"
                        >
                          {service.offerings.sections.map((item, index) => {
                            if (item.showRiceCategory) {
                              return <RiceCategory key={`rice-${index}`} />;
                            }
                            if (item.direction === "rhs") {
                              return (

                                <section
                                  key={index}
                                  className="elementor-section elementor-top-section elementor-element elementor-element-82ce0f0 elementor-section-content-middle elementor-reverse-tablet elementor-reverse-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                  data-id="82ce0f0"
                                  data-element_type="section"
                                >
                                  <div className="elementor-container elementor-column-gap-no">
                                    <div
                                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4fdbc9a"
                                      data-id="4fdbc9a"
                                      data-element_type="column"
                                    >
                                      <div className="elementor-widget-wrap elementor-element-populated">
                                        <section
                                          className="elementor-section elementor-inner-section elementor-element elementor-element-64ef7f2 elementor-section-full_width elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                          data-id="64ef7f2"
                                          data-element_type="section"
                                        >
                                          <div className="elementor-container elementor-column-gap-no">
                                            <div
                                              className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-faf635b"
                                              data-id="faf635b"
                                              data-element_type="column"
                                            >
                                              <div className="elementor-widget-wrap elementor-element-populated">
                                                <div
                                                  className="elementor-element elementor-element-a2f7f15 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                                  data-id="a2f7f15"
                                                  data-element_type="widget"
                                                  data-widget_type="heading.default"
                                                >
                                                  <div className="elementor-widget-container">
                                                    <h2 className="elementor-heading-title elementor-size-default">
                                                      {item.heading}{" "}
                                                    </h2>{" "}
                                                  </div>
                                                </div>
                                                <div
                                                  className="elementor-element elementor-element-9b6b5c2 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                                  data-id="9b6b5c2"
                                                  data-element_type="widget"
                                                  data-widget_type="heading.default"
                                                >
                                                  <div className="elementor-widget-container">
                                                    <p className="elementor-heading-title elementor-size-default">
                                                      {item.content}
                                                    </p>{" "}
                                                  </div>
                                                </div>
                                                <div
                                                  className="elementor-element elementor-element-24e10ee cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                                  data-id="24e10ee"
                                                  data-element_type="widget"
                                                  data-widget_type="heading.default"
                                                >
                                                  <div className="elementor-widget-container">
                                                    <div
                                                      className="elementor-heading-title elementor-size-default"
                                                      style={{ color: "#000" }}
                                                    >
                                                      Key Features
                                                    </div>{" "}
                                                  </div>
                                                </div>
                                                <div
                                                  className="elementor-element elementor-element-1407aea cmsmasters-widget-align-left cmsmasters-widget-layout-row cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                                                  data-id="1407aea"
                                                  data-element_type="widget"
                                                  data-widget_type="cmsmasters-icon-list.default"
                                                >
                                                  <div className="elementor-widget-container">
                                                    <ul className="cmsmasters-widget-icon-list-items">
                                                      {item.keyFeatures.map((ite, ind) => (
                                                        <li key={ind} className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                                          <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                            <span className="cmsmasters-widget-icon-list-item-icon">
                                                              <span>
                                                                <i
                                                                  aria-hidden="true"
                                                                  className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                                                />{" "}
                                                              </span>
                                                            </span>
                                                            <span className="cmsmasters-widget-icon-list-item-text-inner">
                                                              <span className="cmsmasters-widget-icon-list-item-text">
                                                                {ite}
                                                              </span>
                                                            </span>
                                                          </span>
                                                        </li>
                                                      ))}


                                                    </ul>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </section>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-eb093bd"
                                      data-id="eb093bd"
                                      data-element_type="column"
                                    >
                                      <div className="elementor-widget-wrap elementor-element-populated">
                                        <div
                                          className="elementor-element elementor-element-345de95 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                                          data-id="345de95"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div className="elementor-widget-container imghover">
                                            <img
                                              fetchpriority="high"
                                              decoding="async"
                                              width={520}
                                              height={640}
                                              style={{ borderRadius: "20px" }}
                                              src={item.image}
                                              className="attachment-medium_large size-medium_large wp-image-2533 cmsmasters_img cmsmasters-lazyload ls-is-cached lazyloaded"
                                              alt={item.heading}
                                              data-sizes="(max-width: 520px) 100vw, 520px"
                                              // data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1.jpg"
                                              // data-srcset="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1.jpg 520w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-244x300.jpg 244w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-30x37.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-8x10.jpg 8w"
                                              // srcSet="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1.jpg 520w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-244x300.jpg 244w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-30x37.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-8x10.jpg 8w"
                                              sizes="(max-width: 520px) 100vw, 520px"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </section>

                              );
                            }
                            if (item.direction === "lhs") {
                              return (
                                <section
                                  key={index}
                                  className="elementor-section elementor-top-section elementor-element elementor-element-82ce0f0 elementor-section-content-middle elementor-reverse-tablet elementor-reverse-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                  data-id="82ce0f0"
                                  data-element_type="section"
                                >
                                  <div className="elementor-container elementor-column-gap-no">
                                    <div
                                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-eb093bd"
                                      data-id="eb093bd"
                                      data-element_type="column"
                                    >
                                      <div className="elementor-widget-wrap elementor-element-populated">
                                        <div
                                          className="elementor-element elementor-element-345de95 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                                          data-id="345de95"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div className="elementor-widget-container imghover">
                                            <img
                                              fetchpriority="high"
                                              decoding="async"
                                              width={520}
                                              height={640}
                                              src={item.image}
                                              style={{ borderRadius: "20px" }}
                                              className="attachment-medium_large size-medium_large wp-image-2533 cmsmasters_img cmsmasters-lazyload ls-is-cached lazyloaded"
                                              alt={item.heading}
                                              data-sizes="(max-width: 520px) 100vw, 520px"
                                              // data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1.jpg"
                                              // data-srcset="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1.jpg 520w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-244x300.jpg 244w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-30x37.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-8x10.jpg 8w"
                                              // srcSet="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1.jpg 520w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-244x300.jpg 244w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-30x37.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-1-1-8x10.jpg 8w"
                                              sizes="(max-width: 520px) 100vw, 520px"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4fdbc9a"
                                      data-id="4fdbc9a"
                                      data-element_type="column"
                                    >
                                      <div className="elementor-widget-wrap elementor-element-populated">
                                        <section
                                          className="elementor-section elementor-inner-section elementor-element elementor-element-64ef7f2 elementor-section-full_width elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                          data-id="64ef7f2"
                                          data-element_type="section"
                                          style={{ padding: "0% 0% 0% 10%" }}
                                        >
                                          <div className="elementor-container elementor-column-gap-no">
                                            <div
                                              className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-faf635b"
                                              data-id="faf635b"
                                              data-element_type="column"
                                            >
                                              <div className="elementor-widget-wrap elementor-element-populated">
                                                <div
                                                  className="elementor-element elementor-element-a2f7f15 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                                  data-id="a2f7f15"
                                                  data-element_type="widget"
                                                  data-widget_type="heading.default"
                                                >
                                                  <div className="elementor-widget-container">
                                                    <h2 className="elementor-heading-title elementor-size-default">
                                                      {item.heading}{" "}
                                                    </h2>{" "}
                                                  </div>
                                                </div>
                                                <div
                                                  className="elementor-element elementor-element-9b6b5c2 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                                  data-id="9b6b5c2"
                                                  data-element_type="widget"
                                                  data-widget_type="heading.default"
                                                >
                                                  <div className="elementor-widget-container">
                                                    <p className="elementor-heading-title elementor-size-default">
                                                      {item.content}
                                                    </p>{" "}
                                                  </div>
                                                </div>
                                                <div
                                                  className="elementor-element elementor-element-24e10ee cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                                  data-id="24e10ee"
                                                  data-element_type="widget"
                                                  data-widget_type="heading.default"
                                                >
                                                  <div className="elementor-widget-container">
                                                    <div
                                                      className="elementor-heading-title elementor-size-default"
                                                      style={{ color: "#000" }}
                                                    >
                                                      Key Features
                                                    </div>{" "}
                                                  </div>
                                                </div>
                                                <div
                                                  className="elementor-element elementor-element-1407aea cmsmasters-widget-align-left cmsmasters-widget-layout-row cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                                                  data-id="1407aea"
                                                  data-element_type="widget"
                                                  data-widget_type="cmsmasters-icon-list.default"
                                                >
                                                  <div className="elementor-widget-container">
                                                    <ul className="cmsmasters-widget-icon-list-items">
                                                      {item.keyFeatures.map((iter, idx) => (
                                                        <li className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                                          <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                            <span className="cmsmasters-widget-icon-list-item-icon">
                                                              <span>
                                                                <i
                                                                  aria-hidden="true"
                                                                  className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                                                />{" "}
                                                              </span>
                                                            </span>
                                                            <span className="cmsmasters-widget-icon-list-item-text-inner">
                                                              <span className="cmsmasters-widget-icon-list-item-text">
                                                                {iter}
                                                              </span>
                                                            </span>
                                                          </span>
                                                        </li>
                                                      ))}



                                                    </ul>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </section>
                                      </div>
                                    </div>
                                  </div>
                                </section>
                              );
                            }
                            return null;
                          })}


                          {/* whyChooseUs */}
                          <section
                            className="elementor-section elementor-top-section elementor-element elementor-element-12fb713 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                            data-id="12fb713"
                            data-element_type="section"
                          >
                            <div className="elementor-container elementor-column-gap-no">
                              <div
                                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4a422e80"
                                data-id="4a422e80"
                                data-element_type="column"
                              >
                                <div className="elementor-widget-wrap elementor-element-populated">
                                  <div
                                    className="elementor-element elementor-element-ab0f36e cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                    data-id="ab0f36e"
                                    data-element_type="widget"
                                    data-widget_type="heading.default"
                                  >
                                    <div className="elementor-widget-container">
                                      {/* <h2 className="elementor-heading-title elementor-size-default">open your checking account</h2>	 */}
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-element elementor-element-88c50ba cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                    data-id="88c50ba"
                                    data-element_type="widget"
                                    data-widget_type="heading.default"
                                  >
                                    <div
                                      className="elementor-widget-container"
                                      style={{ textAlign: "center" }}
                                    >
                                      <h2 className="elementor-heading-title elementor-size-default">
                                        {service.whyChooseUs.title}
                                      </h2>{" "}
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-element elementor-element-4a1269f cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-text-editor"
                                    data-id="4a1269f"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      {/* <p>The bank account that provides flexible access with more ways to bank</p>	 */}
                                    </div>
                                  </div>
                                  <section
                                    className="elementor-section elementor-inner-section elementor-element elementor-element-4674e00 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                    data-id={4674}
                                    data-element_type="section"
                                  >
                                    <div className="elementor-container elementor-column-gap-wide">
                                      {service.whyChooseUs.points.map(
                                        (point, index) => (
                                          <div
                                            key={index}
                                            className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-89fac1d"
                                            data-id="89fac1d"
                                            data-element_type="column"
                                          >
                                            <div className="elementor-widget-wrap elementor-element-populated">
                                              <div
                                                className="elementor-element elementor-element-53e0c15 elementor-view-default elementor-position-top elementor-mobile-position-top cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-icon-box"
                                                data-id="53e0c15"
                                                data-element_type="widget"
                                                data-widget_type="icon-box.default"
                                              >
                                                <div className="elementor-widget-container">
                                                  <div className="elementor-icon-box-wrapper">
                                                    <div
                                                      className="elementor-icon-box-icon"
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      <span className="elementor-icon">
                                                        <img
                                                          src={point.image}
                                                          width={"40px"}
                                                          height={"40px"}
                                                        />
                                                        {/* <i
aria-hidden="true"
className="cmsmsdemo-icon- cmsms-demo-icon-form-1"
/>{" "} */}
                                                      </span>
                                                    </div>
                                                    <div className="elementor-icon-box-content">
                                                      <h5
                                                        className="elementor-icon-box-title"
                                                        style={{
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        <span
                                                          dangerouslySetInnerHTML={{
                                                            __html: point.title,
                                                          }}
                                                        />

                                                        {/* {point.title}
                                                                                                            </span> */}
                                                      </h5>
                                                      <p
                                                        className="elementor-icon-box-description"
                                                        style={{
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        {point.description}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </div>
                          </section>
                          <section
                            className="elementor-section elementor-top-section elementor-element elementor-element-69476dc elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                            data-id="69476dc"
                            data-element_type="section"
                          >
                            <div className="elementor-container elementor-column-gap-no">
                              <div
                                className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-0fa0bee"
                                data-id="0fa0bee"
                                data-element_type="column"
                              >
                                <div className="elementor-widget-wrap elementor-element-populated">
                                  <div
                                    className="elementor-element elementor-element-81cf52c cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                                    data-id="81cf52c"
                                    data-element_type="widget"
                                    data-widget_type="image.default"
                                  >
                                    <div className="elementor-widget-container imghover">
                                      <img
                                        decoding="async"
                                        width={560}
                                        height={420}
                                        style={{ borderRadius: "20px" }}
                                        src={service.callToAction.image}
                                        className="attachment-medium_large size-medium_large wp-image-2584 cmsmasters_img cmsmasters-lazyload ls-is-cached lazyloaded"
                                        alt=""
                                        data-sizes="(max-width: 560px) 100vw, 560px"
                                        // data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-2-1.jpg"
                                        // data-srcset="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-2-1.jpg 560w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-2-1-300x225.jpg 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-2-1-400x300.jpg 400w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-2-1-30x23.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-2-1-13x10.jpg 13w"
                                        // srcSet="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-2-1.jpg 560w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-2-1-300x225.jpg 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-2-1-400x300.jpg 400w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-2-1-30x23.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-service-2-1-13x10.jpg 13w"
                                        sizes="(max-width: 560px) 100vw, 560px"
                                      />{" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-e85a2b7"
                                data-id="e85a2b7"
                                data-element_type="column"
                              >
                                <div className="elementor-widget-wrap elementor-element-populated">
                                  <section
                                    className="elementor-section elementor-inner-section elementor-element elementor-element-0233274 elementor-section-full_width elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                    data-element_type="section"
                                  >
                                    <div className="elementor-container elementor-column-gap-no">
                                      <div
                                        className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-5f920b3"
                                        data-id="5f920b3"
                                        data-element_type="column"
                                      >
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                          <div
                                            className="elementor-element elementor-element-ffa452f cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                            data-id="ffa452f"
                                            data-element_type="widget"
                                            data-widget_type="heading.default"
                                          >
                                            <div className="elementor-widget-container">
                                              <div className="elementor-heading-title elementor-size-default">
                                                How to apply
                                              </div>{" "}
                                            </div>
                                          </div>
                                          <div
                                            className="elementor-element elementor-element-02af700 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                            data-id="02af700"
                                            data-element_type="widget"
                                            data-widget_type="heading.default"
                                          >
                                            <div className="elementor-widget-container">
                                              <h2 className="elementor-heading-title elementor-size-default">
                                                {service.callToAction.title}
                                              </h2>{" "}
                                            </div>
                                          </div>
                                          <div
                                            className="elementor-element elementor-element-7ceb7c1 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                            data-id="7ceb7c1"
                                            data-element_type="widget"
                                            data-widget_type="heading.default"
                                          >
                                            <div className="elementor-widget-container">
                                              <p className="elementor-heading-title elementor-size-default">
                                                {service.callToAction.content}
                                              </p>{" "}
                                            </div>
                                          </div>
                                          <div
                                            className="elementor-element elementor-element-7b9317d cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                                            data-id="7b9317d"
                                            data-element_type="widget"
                                            data-widget_type="cmsmasters-button.default"
                                          >
                                            <div className="elementor-widget-container">
                                              <div className="elementor-widget-cmsmasters-button__button-container">
                                                <div className="elementor-widget-cmsmasters-button__button-container-inner">
                                                  <a
                                                    href={
                                                      service.callToAction
                                                        .buttonLink
                                                    }
                                                    className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view- cmsmasters-icon-shape- cmsmasters-button-size-sm"
                                                    role="button"
                                                  >
                                                    <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-">
                                                      <span className="elementor-widget-cmsmasters-button__text">
                                                        {
                                                          service.callToAction
                                                            .buttonText
                                                        }
                                                      </span>
                                                    </span>
                                                  </a>
                                                </div>
                                              </div>{" "}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </div>
                          </section>
                          <FaqPage />
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Service;
